<template>
    <div class="page-wrapper">
        <v-snackbar
                v-model="notification"
                :color="notification_type"
                :timeout="5000"
                :top="true"
        >
            {{ notification_message }}
            <v-btn

                    text
                    @click="notification = false"
            >
                Close
            </v-btn>
        </v-snackbar>

        <v-container
                fill-height
                fluid
                grid-list-xl>
            <v-layout
                    justify-center
                    wrap>
                <v-flex xs12>
                    <v-card
                            class="pa-4"
                            flat
                    >
                        <v-toolbar
                                dense
                        >
                            <v-text-field
                                    hide-details
                                    single-line
                                    label="Name"
                                    v-model="search.name"
                            ></v-text-field>

                            <v-btn
                                    @click="filter_results(search)"
                                    icon
                                    color="blue-grey darken-4">
                                <v-icon>
                                    mdi-magnify
                                </v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                </v-flex>

                <v-flex
                        xs12
                        md12
                >
                    <v-data-table
                            :headers="headers"
                            :items="products"
                            :server-items-length="totalItems"
                            :page.sync="page"
                            :items-per-page="itemsPerPage"
                            hide-default-footer
                            @page-count="pageCount = $event"
                            class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Products</v-toolbar-title>
                                <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                ></v-divider>
                                <v-spacer></v-spacer>
                                <v-dialog v-model="dialog"
                                          :persistent="true"
                                          max-width="500px">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="blue-grey darken-4" dark class="mb-2" v-on="on">New products
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container grid-list-md>
                                                <v-layout wrap>
                                                    <v-flex xs12>
                                                        <v-text-field
                                                                v-model="editedItem.name"
                                                                :counter="500"
                                                                label="Name"
                                                                required
                                                                :error-messages="checkName"
                                                                @input="$v.editedItem.name.$touch()"
                                                                @blur="$v.editedItem.name.$touch()"
                                                        ></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12>
                                                        <v-text-field
                                                                v-model="editedItem.price"
                                                                label="Price"
                                                                required
                                                                :error-messages="checkPrice"
                                                                @input="$v.editedItem.price.$touch()"
                                                                @blur="$v.editedItem.price.$touch()"

                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-autocomplete
                                                                v-model="editedItem.category"
                                                                :loading="false"
                                                                :items="categories"
                                                                item-text="name"
                                                                item-value="id"
                                                                label="Category"
                                                                flat
                                                                hide-no-data="" hide-details=""></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-select
                                                                v-model="editedItem.happy_hour_type"
                                                                :items="happy_hour_opts"
                                                                item-value="id"
                                                                item-text="name"
                                                                required
                                                                :error-messages="checkHappyHourType"
                                                                @input="$v.editedItem.happy_hour_type.$touch()"
                                                                @blur="$v.editedItem.happy_hour_type.$touch()"
                                                                label="Happy Hour Type"
                                                        ></v-select>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-text-field
                                                                v-model="editedItem.happy_hour_amount"
                                                                label="Happy Hour Amount"
                                                                required
                                                                :error-messages="checkHappyHourAmount"
                                                                @input="$v.editedItem.happy_hour_amount.$touch()"
                                                                @blur="$v.editedItem.happy_hour_amount.$touch()"

                                                        ></v-text-field>
                                                    </v-flex>

                                                </v-layout>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn
                                    color="blue-grey darken-4"
                                    @click="editItem(item)"
                            >
                                <v-icon>
                                    mdi-pencil
                                </v-icon>
                            </v-btn>
                            <v-btn
                                    class="mx-2"
                                    color="blue-grey darken-4"
                                    @click="deleteItem(item)"
                            >
                                <v-icon>
                                    mdi-delete
                                </v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.category_t="{ item }" class="text-center">
                            {{ categories.find(o => o.id === item.category).name }}
                        </template>
                        <template v-slot:item.happy_hour_type_t="{ item }" class="text-center">
                            {{ happy_hour_opts.find(o => o.id === item.happy_hour_type).name }}
                        </template>

                    </v-data-table>
                    <div class="text-center pt-2">
                        <v-pagination v-model="page" :length="pageCount"></v-pagination>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>

    </div>
</template>


<script>
    import {validationMixin} from 'vuelidate'
    import {required, maxLength, minLength, email, decimal, numeric} from 'vuelidate/lib/validators'

    export default {
        components: {},
        mixins: [validationMixin],

        validations: {
            editedItem: {
                name: {
                    required,
                    maxLength: maxLength(500),
                    minLength: minLength(1)
                },
                price: {
                    required,
                    decimal,
                },
                category: {
                    required
                },
                happy_hour_type: {
                    required
                },
                happy_hour_amount: {
                    required,
                    numeric
                }
            }

        },
        data() {
            return {
                headers: [
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: false,
                        value: 'name',
                    },
                    {
                        text: 'Price',
                        align: 'left',
                        sortable: false,
                        value: 'price',
                    },
                    {
                        text: 'Category',
                        align: 'left',
                        sortable: false,
                        value: 'category_t',
                    },
                    {
                        text: 'Happy Hour Type',
                        align: 'left',
                        sortable: false,
                        value: 'happy_hour_type_t',
                    },
                    {
                        text: 'Happy Hour Amount',
                        align: 'left',
                        sortable: false,
                        value: 'happy_hour_amount',
                    },
                    {
                        text: 'Actions',
                        align: 'center',
                        sortable: false,
                        value: 'action'

                    }
                ],
                notification_type: 'success',
                notification_message: '',
                notification: false,
                dialog: false,
                products: [],
                editedIndex: -1,
                editedItem: {
                    id: 0,
                    name: '',
                    price: 0,
                    category: 1,
                    happy_hour_amount: 0,
                    happy_hour_type: 2
                },
                defaultItem: {
                    id: 0,
                    name: '',
                    price: 0,
                    category: 1,
                    happy_hour_amount: 0,
                    happy_hour_type: 2
                },
                page: 1, //default load page
                pageCount: 0,
                itemsPerPage: 20, //items shown per page,
                totalItems: 0,
                categories: [],
                happy_hour_opts: [
                    {
                        id: 1,
                        name: 'Different Price During HH'
                    },
                    {
                        id: 2,
                        name: 'Buy One Get One'
                    }
                ],
                search: {},
                search_url: ''
            }
        },
        computed: {
            checkName() {
                const errors = [];
                if (!this.$v.editedItem.name.$dirty) return errors;
                !this.$v.editedItem.name.maxLength && errors.push('name must be at most 500 characters long');
                !this.$v.editedItem.name.minLength && errors.push('name must be at least 1 characters long');
                !this.$v.editedItem.name.required && errors.push('name is required.');
                return errors;
            },
            checkPrice() {
                const errors = [];
                if (!this.$v.editedItem.price.$dirty) return errors;
                !this.$v.editedItem.price.decimal && errors.push('.price must be a valid decimal exmp: 0.00');
                !this.$v.editedItem.price.required && errors.push('.price is required.');
                return errors;
            },
            checkCategory() {
                const errors = [];
                if (!this.$v.editedItem.category.$dirty) return errors;
                !this.$v.editedItem.category.required && errors.push('.category is required.');
                return errors;
            },
            checkHappyHourType() {
                const errors = [];
                if (!this.$v.editedItem.happy_hour_type.$dirty) return errors;
                !this.$v.editedItem.happy_hour_type.required && errors.push('editedItem.happy_hour_type is required.');
                return errors;
            },
            checkHappyHourAmount() {
                const errors = [];
                if (!this.$v.editedItem.happy_hour_amount.$dirty) return errors;
                !this.$v.editedItem.happy_hour_amount.numeric && errors.push('.happy_hour_amount must be a number value');
                !this.$v.editedItem.happy_hour_amount.required && errors.push('.happy_hour_amount is required. If promo is Buy One Get one put 0');
                return errors;
            },
            formTitle() {
                return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
            },
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
        },
        created() {
            this.load_products(this.page);

        },
        methods: {
            load_products(page_no) {
                let offset = (page_no - 1) * this.itemsPerPage;
                let limit = this.itemsPerPage;

                this.$http.get(
                    this.$http.defaults.baseURL + '/admin/products/?limit=' + limit + '&offset=' + offset + this.search_url).then((response) => {
                    this.products = response.data.results;
                    this.notification = false;
                    this.notification_message = '';
                    this.totalItems = (response.data.count / this.itemsPerPage);
                    this.load_categories();

                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },
            load_categories() {
                this.$http.get(
                    this.$http.defaults.baseURL + '/admin/categories-all/').then((response) => {
                        this.categories = response.data;
                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },
            editItem(item) {
                this.editedIndex = this.products.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            deleteItem(item) {
                const index = this.products.indexOf(item);
                if (confirm('Are you sure you want to delete this item?')) {
                    this.$http.delete(
                        this.$http.defaults.baseURL + '/admin/products/' + item.id + '/').then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Deleted';
                        this.products.splice(index, 1);

                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                }, 300)
            },

            save() {
                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.notification = true;
                    this.notification_type = 'red darken-2';
                    this.notification_message = 'Please fill the form out correctly';
                    return false;
                }
                if (this.editedIndex > -1) {
                    this.$http.patch(
                        this.$http.defaults.baseURL + '/admin/products/' + this.editedItem.id + '/', this.editedItem).then((response) => {
                        this.notification = true;
                        this.notification_type = 'success';

                        this.notification_message = 'Successfully Saved';
                        Object.assign(this.products[this.editedIndex], this.editedItem)
                        this.close()
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });


                } else {
                    this.$http.post(
                        this.$http.defaults.baseURL + '/admin/products/', this.editedItem).then((response) => {
                        this.notification = true;
                        this.notification_type = 'success';

                        this.notification_message = 'Successfully Saved';
                        console.log(response);
                        this.products.push(response.data);
                        this.close()
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }

            },
            filter_results(search) {
                let search_url = '';
                for (let prop in search) {
                    // skip loop if the property is from prototype
                    if (!search.hasOwnProperty(prop)) continue;

                    // your code
                    search_url += '&' + prop + '=' + search[prop];
                }
                this.search_url = search_url;
                this.load_products(1);
                this.page = 1;
            }
        },
    }
</script>
